import React from 'react';
import { Input } from '@/components/ui/input';

const PhoneInput = ({ value, onChange, ...props }) => {
  const formatPhoneNumber = (input) => {
    // Remove all non-digit characters
    const digits = input.replace(/\D/g, '');
    
    // Limit to 10 digits
    const limited = digits.slice(0, 10);
    
    // Format based on length
    if (limited.length <= 3) {
      return limited;
    } else if (limited.length <= 6) {
      return `(${limited.slice(0, 3)}) ${limited.slice(3)}`;
    } else {
      return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`;
    }
  };

  const handleChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    // Create a synthetic event object to match standard input behavior
    const syntheticEvent = {
      target: {
        name: e.target.name,
        value: formatted
      }
    };
    // Call parent onChange with the synthetic event
    onChange(syntheticEvent);
  };

  return (
    <Input
      {...props}
      type="tel"
      value={value || ''}
      onChange={handleChange}
      placeholder="(555) 123-4567"
      maxLength={14} // (555) 123-4567 = 14 chars
    />
  );
};

export default PhoneInput;
